export function PageHeader({ eyebrow, title, subtitle, actions, testId }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10"
    >
      <div>
        {eyebrow && (
          <div className="text-xs tracking-[0.15em] uppercase text-[#141B4D]/60 mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="text-4xl md:text-5xl tracking-tight font-bold text-[#141B4D] leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 text-base text-[#141B4D]/70 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
